import { Game } from '../enum/game.enum';
import { Language } from '../enum/language.enum';

export interface GameConfig {
  assetsPath: string;
  botName: string;
  certificate: string;
  game: Game;
  hasLearnings: boolean;
  languages: Language[];
  levelIndicatorIsIcon: boolean;
  levels: number;
  urlBase: string;
}

export const ASSETS_PATH = 'assets';
export const DEFAULT_GAME_CONFIG = {
  ...createDefaultConfig(Game.GANDALF),
  urlBase: '',
};

function createDefaultConfig(game: Game): GameConfig {
  return {
    assetsPath: `${ASSETS_PATH}/${game.toString()}`,
    certificate: 'prompt-refine-repeat-certificate',
    game,
    languages: [Language.EN, Language.DE],
    levelIndicatorIsIcon: false,
    levels: 6,
    urlBase: game.toString(),
    hasLearnings: true,
    botName: 'Maria',
  }
}

export const gameConfigs: Record<Game, GameConfig> = {
  gandalf: DEFAULT_GAME_CONFIG,
  vision0: {
    ...createDefaultConfig(Game.VISION0),
    certificate: 'vision0-certificate',
    hasLearnings: false,
    levels: 5,
    levelIndicatorIsIcon: true,
    botName: 'Essie',
  },
};
